export default __webpack_public_path__ + "media/icons/carouselArrowPrev-f76bc731.svg";